package de.ohhhmhhh.backend.models.model.text

import kotlinx.serialization.Serializable

@Serializable
enum class StaticTextTypeEntity {
    PLAIN, STRUCTURED
}